export default "__VITE_ASSET__DnDbgd63__"